<template>
    <div class="checkout relative">
    <VivaLoader />
    <HeaderDashboard />
        <main class="checkout-component bg-gray-50 pt-16 md:pt-36 pb-10">
            <div class="mx-auto flex flex-col md:flex-row max-w-7xl container">
                <DashboardSidebarMenu isPage="suscripción"/>
                <div class="main-content w-full md:w-4/5 flex flex-col">
                    <section class="mb-5">
                        <div class="max-w-6xl mx-auto px-4">
                            <div class="box sm:px-10 pt-10 pb-4 w-full">
                                <SubscriptionConfiguration />
                            </div>
                        </div>
                    </section>
                    <section class="mb-5 hidden" >
                        <div class="max-w-6xl mx-auto px-4">
                            <div class="flex flex-col-reverse md:flex-row justify-between w-full py-10 px-10 bg-blue-200 text-white rounded-lg">
                                <div class="w-full md:w-2/3 flex flex-col justify-center pr-0 md:mb-0 md:pr-12">
                                    <div>
                                        <div class="text-white text-xs flex flex-row mb-2">
                                            <span class="inline text-xs">
                                                Añade acompañantes hasta el {{getMemberSince }}
                                            </span>
                                        </div>
                                        <h2 class="text-white font-semibold text-xl mb-3">Agrega más acompañantes a tu membresía</h2>
                                        <p class="text-white text-md">Comparte el beneficio de descuento Viva Fan con hasta 8 personas. Recuerda que deben estar incluidas en tu reserva para que disfruten el descuento.</p>
                                    </div>
                                    <div class="mt-5">
                                        <button class="bg-orange rounded-xl text-white py-4 px-10 font-semibold hover:bg-blue-100">
                                            Actualizar membresía
                                        </button>
                                    </div>
                                </div>
                                <div class="w-1/3 mb-6 md:mb-0">
                                    <div class="w-60 block flex justify-center content-center items-center">
                                        <img src="/assets/img/dashboard/team-upgrade-membresía.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    <FooterCheckout />
    </div>
</template>

<script>
import HeaderDashboard from "@/components/header/Header.vue"
import FooterCheckout from "@/components/Footer.vue"
import DashboardSidebarMenu from "@/components/dashboard/SidebarMenu.vue"
import SubscriptionConfiguration from "@/components/subscription/SubscriptionConfiguration.vue"
import VivaLoader from "@/components/loader/Loader.vue"
import { computed } from "@vue/reactivity"
import { useStore } from "vuex"

export default({
    name: 'ModifySubscription', 
    components: {
        HeaderDashboard,
        FooterCheckout,
        DashboardSidebarMenu,
        SubscriptionConfiguration,
        VivaLoader
    },
    setup(){
        const store = useStore()
        const subscription = computed(() => {
            return store.state.Checkout.data.userSubscription.data

        })
          const getMemberSince = computed( () => {
             if( subscription.value ){
                const expire = new Date(subscription.value.subscription.creationDate )
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                return expire.toLocaleDateString('es-ES', options)
             }
        })

        return { getMemberSince }
    }
})
</script>

<style scoped>
.section-header {
	@apply text-3xl text-green-400 font-semibold md:font-bold;
}
.box {
    @apply bg-white border border-gray-200 shadow rounded-lg text-left rounded-lg shadow overflow-hidden;
}
h5 {
    @apply md:text-sm text-green-400;
    font-size: 0.75rem;
}
input.form-control, select.form-control{
    @apply font-semibold text-left focus:ring-green-400 focus:border-green-400 block w-full text-18 border-gray-300 rounded-md pt-7 pb-2 px-4 rounded-xl shadow-sm border text-green-500 outline-none;
}
label > span {
    @apply text-green-500 sm:text-xs;
}
.form-check-radio {
    @apply w-5 h-5 border-2 rounded-full bg-blue-100;
}
.form-radio-wrapper {
    @apply flex content-center items-center pt-5 pb-0 md:py-5 w-full md:w-auto;
}
.disabled {
    @apply opacity-50 cursor-not-allowed
}
</style>